import React from 'react';

/**
 * Read-only linked accounts status from profile loginType (how the user signed up).
 * No link/unlink actions.
 */
export function LinkedAccountsModal({ isOpen, onClose, loginType }) {
    if (!isOpen) return null;

    const googleConnected = loginType === 'google';
    const facebookConnected = loginType === 'facebook';

    return (
        <div className="profile-modal-overlay" onClick={onClose}>
            <div className="profile-modal" onClick={(e) => e.stopPropagation()}>
                <div className="profile-modal-header">
                    <h3>Linked accounts</h3>
                    <button type="button" className="profile-modal-close" onClick={onClose} aria-label="Close">
                        ×
                    </button>
                </div>
                <div className="profile-modal-body">
                    <p className="linked-accounts-intro">
                        {googleConnected && 'You signed in with Google.'}
                        {facebookConnected && 'You signed in with Facebook.'}
                        {!googleConnected && !facebookConnected && 'You signed up with your phone number.'}
                    </p>
                    <div className="linked-accounts-list">
                        <div className="linked-accounts-provider">
                            <div className="linked-accounts-provider-info">
                                <i className="bi bi-google" />
                                <span>Google</span>
                            </div>
                            {googleConnected ? (
                                <span className="linked-accounts-status linked-accounts-status--connected">Connected</span>
                            ) : (
                                <span className="linked-accounts-status linked-accounts-status--soon">Not linked</span>
                            )}
                        </div>
                        <div className="linked-accounts-provider">
                            <div className="linked-accounts-provider-info">
                                <i className="bi bi-facebook" />
                                <span>Facebook</span>
                            </div>
                            {facebookConnected ? (
                                <span className="linked-accounts-status linked-accounts-status--connected">Connected</span>
                            ) : (
                                <span className="linked-accounts-status linked-accounts-status--soon">Coming soon</span>
                            )}
                        </div>
                        <div className="linked-accounts-provider">
                            <div className="linked-accounts-provider-info">
                                <i className="bi bi-apple" />
                                <span>Apple</span>
                            </div>
                            <span className="linked-accounts-status linked-accounts-status--soon">Coming soon</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
